export default __webpack_public_path__ + "static/media/mosaic-new-2.1614faf7.png";